import PropTypes from "prop-types";

import { useEffect, useState } from "react";

import Card from "react-bootstrap/Card";

import {
  WORKSPACE_TYPE_PRIVATE,
  WORKSPACE_TYPE_PUBLIC,
  TILE_TYPE_GROUP_OF_TILES,
} from "../../constants/stringConstants";

import DesignedLabel from "../DesignedLabel";

import { useTranslation } from "react-i18next";

import iconsEdit from "../../assets/svg/icons-edit.svg";

import iconsDelete from "../../assets/svg/icons-delete.svg";
import { formatDate } from "../formatDate";
import CustomModal from "../CustomModal";

import { deleteTile, updateTile } from "../../actions/tileActions";

import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";

import FieldsInForm from "../../utils/FieldsInForm";

import {
  addNewsItem,
  addNewsItemAction,
  filterFailureMessageRaised,
  filterSuccessMessageRaised,
  getFilterTypes,
} from "../../actions/filterActions";

import iconsCrossLink from "../../assets/svg/icons-crossLink.svg";

import iconsExternalLink from "../../assets/svg/icons-externalLink.svg";

import iconsAddToList from "../../assets/svg/icons-addToList-second.svg";
import { ADD_NEWS } from "../../constants/urls";
import axios from "axios";
import AlertMessage from "../AlertMessage";

const CardSourceCustom = ({
  card,
  userEmail,
  singleTopic,
  userToken,
  deleteTile,
  updateTile,
  currentWorkspace,
  id,
  fromDocumentContainer,
  fromCardAssessmentContainer,
  singleTile,
  // addNewsItem,
  getFilterTypes,
  tileTypes,
}) => {
  const { t } = useTranslation();
  const [textIsClicked, setTextIsClicked] = useState(false);
  const [isDeletedDialogOpened, setIsDeletedDialogOpened] = useState(false);
  const [isEditDialogOpened, setIsEditDialogOpened] = useState(false);
  const [tile_value_is_changing, setTileValueInChanging] = useState(
    card.TILE_VALUE === " "
      ? [{ LINK_NAME: "", LINK_URL: "" }]
      : [
          {
            LINK_NAME: card.TILE_VALUE.split(";")[0],
            LINK_URL: card.TILE_VALUE.split(";")[1],
          },
        ]
  );
  const [links_to_delete, setLinksToDelete] = useState([]);
  const [tile_audience, setTileAudience] = useState(card.TILE_AUDIENCE);
  const [tile_name, setTileName] = useState(card.TILE_NAME);
  const [submitOccurred, setSubmitOccurred] = useState(false);
  const [isPushedDialogOpened, setIsPushedDialogOpened] = useState(false);
  const [url, setUrl] = useState("");
  const argsForEditTextTileDialog = {
    findFormErrors: () => {
      const newErrors = {};

      if (!tile_name || tile_name === "")
        newErrors.TILE_NAME = t("tileNameIsMandatory");
      else if (tile_name.length > 255)
        newErrors.TILE_NAME = t("tileNameCantBeLongerThan255Charachteres");

      tile_value_is_changing.forEach((value) => {
        if (!value["LINK_NAME"] || !value["LINK_URL"]) {
          newErrors.TILE_VALUE = t("noneOfTheLinkFieldsMustNotBeEmpty");
        }
      });

      return newErrors;
    },
    fieldsForEditLinksTile: [
      {
        name: "TILE_NAME",
        type: "text",
        className: "register-login-text-field",
        required: true,
        classnameofgroup: "register-login-text-field-group",
        label: t("nameTheTile"),
        placeholder: t("egIdentifiedRisks"),
        onChangeText: (value) => setTileName(value),
        value: tile_name,
      },
      {
        name: "TILE_AUDIENCE",
        type: "select",
        className: "register-login-text-field",
        options: [
          {
            description: t("privateWorkspace"),
            value: WORKSPACE_TYPE_PRIVATE,
          },
          { description: t("publicWorkspace"), value: WORKSPACE_TYPE_PUBLIC },
        ],
        required: true,
        disabled: currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE,
        displayProperty: "description",
        valueProperty: "value",
        label: t("tileAudience"),
        onChange: (value) => setTileAudience(value),
        value: tile_audience,
      },
      {
        name: "TILE_VALUE",
        type: "multiple-text-fields-in-a-row",
        className: "register-login-text-field",
        data: tile_value_is_changing,
        required: true,
        first_display_property: "LINK_NAME",
        second_display_property: "LINK_URL",
        first_field_label: t("sourceName"),
        second_field_label: t("sourceUrl"),
        labelOfBottomButton: undefined,
        first_field_placeholder: t("exampleTitle"),
        second_field_placeholder: t("exampleURL"),
        addARow: () => {
          let link = { LINK_NAME: "", LINK_URL: "" };

          setTileValueInChanging((tile_value_is_changing) => [
            ...tile_value_is_changing,
            link,
          ]);
        },
        removeARow: (index) => {
          let helpArray = [],
            deleteHelpArray = links_to_delete;

          tile_value_is_changing.forEach((value, localIndex) => {
            if (index !== localIndex) {
              helpArray.push(value);
            }

            if (index === localIndex && value.LINK_ID) {
              deleteHelpArray.push(value);
            }
          });

          setTileValueInChanging(helpArray);
          setLinksToDelete(deleteHelpArray);
        },
        changeOfValue: (valueProperty, value, index) => {
          let helpArray = [];

          tile_value_is_changing.forEach((localValue, localIndex) => {
            if (index === localIndex) {
              localValue[valueProperty] = value;
            }

            helpArray.push(localValue);
          });

          setTileValueInChanging(helpArray);
        },
      },
    ],
    onSubmit: () => {
      let tile_value_local = "";

      setIsEditDialogOpened(false);

      tile_value_is_changing.forEach(
        (o) => (tile_value_local += o.LINK_NAME + ";" + o.LINK_URL)
      );

      // updateTile(
      //   userToken,
      //   card.TILE_ID,
      //   tile_name,
      //   tile_value_local,
      //   tile_audience,
      //   card.TILE_TYPE,
      //   fromDocumentContainer
      //     ? id
      //     : fromCardAssessmentContainer
      //     ? singleTile.TILE_ID
      //     : singleTopic.TOPIC_ID,
      //   fromCardAssessmentContainer ? TILE_TYPE_GROUP_OF_TILES : undefined
      // );
      updateTile({
        usertoken: userToken,
        tile_id: card.TILE_ID,
        tile_name: tile_name,
        tile_value: tile_value_local,
        tile_audience: tile_audience,
        tile_type: card.TILE_TYPE,
        topic_id: fromDocumentContainer
          ? id
          : fromCardAssessmentContainer
          ? singleTile.TILE_ID
          : singleTopic.TOPIC_ID,
        tile_types: fromCardAssessmentContainer
          ? TILE_TYPE_GROUP_OF_TILES
          : undefined,
      });

      //   setTimeout(function () {
      //     tile_value_is_changing.forEach((singleTileLink) => {
      //       if (singleTileLink.LINK_ID === undefined) {
      //         addLink(
      //           userToken,
      //           card.TILE_ID,
      //           singleTileLink.LINK_NAME,
      //           singleTileLink.LINK_URL,
      //           "",
      //           singleTopic.TOPIC_ID
      //         );
      //       }
      //     });

      //     links_to_delete.forEach((singleTileLink) => {
      //       removeLink(userToken, singleTileLink.LINK_ID, singleTopic.TOPIC_ID);
      //     });

      //     setLinksToDelete([]);
      //   });
    },
  };
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const [html, setHtml] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    setUrl(window.location.href);
    getFilterTypes(userToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let markup = document?.getElementById("linkForPush_source")?.outerHTML;
    setHtml(markup);
  }, []);

  let title = singleTopic.TOPIC_NAME;

  const matchingObjects = tileTypes.filter(
    (obj) => obj.TILE_TYPE_NAME === card.TILE_TYPE
  );

  return (
    <>
      <Card
        className={
          card.TILE_AUDIENCE !== WORKSPACE_TYPE_PRIVATE
            ? "card-tile card-tile-text"
            : "card-tile card-tile-private card-tile-text"
        }
      >
        <Card.Header>
          <div className="cardHeaderWrapper">
            {matchingObjects &&
              matchingObjects.map((item) => (
                <img
                  width={30}
                  height={30}
                  key={item.TILE_NAME}
                  src={item.TILE_TYPE_ICON_PATH}
                  alt={item.TILE_NAME}
                />
              ))}
            <span className="tile-name">{card.TILE_NAME}</span>
          </div>
          <DesignedLabel
            label={WORKSPACE_TYPE_PRIVATE.toUpperCase()}
            classNameLabel={
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE
                ? "private-label"
                : "display-none"
            }
          />
          <DesignedLabel
            label={t("partnerContent").toUpperCase()}
            classNameLabel={
              (card.PARTNER === "TRUE" || card.PARTNER === true) &&
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PUBLIC
                ? "partner-content-label"
                : "display-none"
            }
          />
        </Card.Header>
        <Card.Title
          className={
            card.TILE_AUDIENCE !== WORKSPACE_TYPE_PRIVATE &&
            card.CREATED_BY !== userEmail
              ? "tile-created-by"
              : "tile-created-by visibility-hidden"
          }
        >
          {t("createdBy") + ": "}
          <img
            width={24}
            height={24}
            src={card.CREATOR_LOGO}
            className={
              card.CREATOR_LOGO ? "created-by-logo-tile" : "display-none"
            }
          />
          {card.CREATED_BY}
        </Card.Title>
        <Card.Body
          className="tile-body cursor-pointer"
          onClick={() => setTextIsClicked(true)}
        >
          {/* <Card.Title
            className={
              card.TILE_AUDIENCE !== WORKSPACE_TYPE_PRIVATE &&
              card.CREATED_BY !== userEmail
                ? "tile-created-by"
                : "tile-created-by visibility-hidden"
            }
          >
            {t("createdBy") + ": "}
            <img
              width={24}
              height={24}
              src={card.CREATOR_LOGO}
              className={
                card.CREATOR_LOGO ? "created-by-logo-tile" : "display-none"
              }
            />
            {card.CREATED_BY}
          </Card.Title> */}
          <Card.Text className="tile-text cursor-pointer">
            <div className="impact-tile source-tile">
              {tile_value_is_changing.map((link, index) => {
                return (
                  <>
                    <span className="tile-img-container" key={index}>
                      {link.LINK_URL.includes(".jpg" || ".png") && (
                        <img className="tile-img" src={link.LINK_URL} />
                      )}
                    </span>

                    <span
                      key={link.LINK_NAME + index}
                      className="link"
                      onClick={() => {
                        let finalLink =
                          link.LINK_URL.includes("https://") ||
                          link.LINK_URL.includes("http://")
                            ? link.LINK_URL
                            : "https://" + link.LINK_URL;
                        window.open(
                          finalLink,
                          link.LINK_URL.includes("app.reghub.io")
                            ? "_self"
                            : "_blank"
                        );

                        setTimeout(function () {
                          setTextIsClicked(false);
                        });
                      }}
                    >
                      <img
                        width={24}
                        height={24}
                        src={
                          link.LINK_URL.includes("app.reghub.io")
                            ? iconsCrossLink
                            : iconsExternalLink
                        }
                        className={link.LINK_URL ? "link-icon" : "display-none"}
                      />
                      <span className="link-name"> {link.LINK_NAME} </span>
                    </span>
                  </>
                );
              })}
            </div>
          </Card.Text>
          <div style={{ display: "none" }}>
            <div id="linkForPush_source">
              <Card.Text className="tile-text cursor-pointer">
                <div className="impact-tile source-tile">
                  {tile_value_is_changing.map((link, index) => {
                    return (
                      <div
                        key={link.LINK_NAME + index}
                        className="source-full-view"
                      >
                        <span className="source-link-name">
                          {link.LINK_NAME}
                        </span>
                        <span
                          className="link"
                          onClick={() => {
                            let finalLink =
                              link.LINK_URL.includes("https://") ||
                              link.LINK_URL.includes("http://")
                                ? link.LINK_URL
                                : "https://" + link.LINK_URL;
                            window.open(
                              finalLink,
                              link.LINK_URL.includes("app.reghub.io")
                                ? "_self"
                                : "_blank"
                            );
                          }}
                        >
                          <img
                            width={24}
                            height={24}
                            src={
                              link.LINK_URL.includes("app.reghub.io")
                                ? iconsCrossLink
                                : iconsExternalLink
                            }
                            className="link-icon-source-icon"
                          />
                          <span className="link-name-source">
                            {" "}
                            {link.LINK_URL}{" "}
                          </span>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </Card.Text>
            </div>
          </div>
        </Card.Body>
        <Card.Footer className="tile-footer">
          <Card.Text className="tile-last-updated">
            {t("lastUpdated") +
              ": " +
              formatDate(new Date(card.TILE_LAST_UPDATE), "dd.mm.yyyy")}
          </Card.Text>
          <Card.Text
            className={
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE ||
              card.CREATED_BY === userEmail
                ? "tile-edit-or-updated"
                : "display-none"
            }
          >
            {(card.TILE_AUDIENCE !== WORKSPACE_TYPE_PRIVATE ||
              card.PARTNER === "TRUE" ||
              card.PARTNER === true) && (
              <span
                onClick={() => setIsPushedDialogOpened(true)}
                className="card-topic-group-footer-option"
              >
                <img
                  width={32}
                  height={32}
                  src={iconsAddToList}
                  className="card-topic-group-footer-img-add"
                />
                {t("push")}
              </span>
            )}
            <span
              onClick={() => setIsEditDialogOpened(true)}
              className="card-topic-group-footer-option"
            >
              <img
                width={24}
                height={24}
                src={iconsEdit}
                className="card-topic-group-footer-img"
              />
              {t("edit")}
            </span>
            <span
              className="card-topic-group-footer-option"
              onClick={() => setIsDeletedDialogOpened(true)}
            >
              <img
                width={24}
                height={24}
                src={iconsDelete}
                className="card-topic-group-footer-img"
              />
              {t("delete")}
            </span>
          </Card.Text>
        </Card.Footer>
      </Card>
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("pushNews")}
        setIsShown={setIsPushedDialogOpened}
        isShown={isPushedDialogOpened}
        negativeAction={() => setIsPushedDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("youAreAboutToPushATile")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("areYouSureYouWantToPushATile")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("pushNews")}
        positiveAction={() => {
          // let newsValues = {
          //   NEWS_TITLE: card.TILE_NAME,
          //   NEWS_DESCRIPTION: html || "There is no description",
          //   NEWS_CONTENT: html || "There is no content",
          //   NEWS_COUNTRY: "Global",
          //   NEWS_URL: url,
          //   NEWS_PUBLICATION_TYPE: "Assessments",
          //   NEWS_PUBLISHER: card.CREATED_BY,
          //   NEWS_PUBLISHER_TYPE: "Information Provider",
          //   NEWS_DATE: card.TILE_LAST_UPDATE,
          //   NEWS_TOPICS: title,
          //   NEWS_CURATED: "yes",
          // };
          // addNewsItem(
          //   userToken,
          //   newsValues.NEWS_TITLE,
          //   newsValues.NEWS_DESCRIPTION,
          //   newsValues.NEWS_CONTENT,
          //   newsValues.NEWS_COUNTRY,
          //   newsValues.NEWS_URL,
          //   newsValues.NEWS_PUBLICATION_TYPE,
          //   newsValues.NEWS_PUBLISHER,
          //   newsValues.NEWS_PUBLISHER_TYPE,
          //   newsValues.NEWS_DATE,
          //   newsValues.NEWS_CURATED,
          //   newsValues.NEWS_TOPICS
          // );
          let axiosConfig = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };

          let bodyFormData = new FormData();
          bodyFormData.append("usertoken", userToken);
          bodyFormData.append("news_title", card.TILE_NAME);
          bodyFormData.append("description", html);
          bodyFormData.append("content", html);
          bodyFormData.append("country", "Global");
          bodyFormData.append("url", url);
          bodyFormData.append("publication_type", "Assessments");
          bodyFormData.append("publisher", card.CREATED_BY);
          bodyFormData.append("publisher_type", "Information Provider");
          bodyFormData.append("publication_date", card.TILE_LAST_UPDATE);
          bodyFormData.append("topics", title);
          bodyFormData.append("curated", "yes");

          const asString = new URLSearchParams(bodyFormData).toString();

          axios
            .post(ADD_NEWS, asString, axiosConfig)
            .then((response) => {
              dispatch(addNewsItemAction(response.data.RegHub_response));
              setSuccessMessage("The news has been added successfully.");
            })
            .catch((err) => {
              setFailureMessage(err?.response?.data);
            });

          setIsPushedDialogOpened(false);
        }}
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("deleteATile")}
        setIsShown={setIsDeletedDialogOpened}
        isShown={isDeletedDialogOpened}
        negativeAction={() => setIsDeletedDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("youAreAboutToDeleteATile")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("areYouSureYouWantToDeleteATile")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("deleteATile")}
        positiveAction={() =>
          deleteTile(
            userToken,
            card.TILE_ID,
            fromDocumentContainer
              ? id
              : fromCardAssessmentContainer
              ? singleTile.TILE_ID
              : singleTopic.TOPIC_ID,
            fromCardAssessmentContainer ? TILE_TYPE_GROUP_OF_TILES : undefined
          )
        }
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal edit-tile-modal"
        titleOfModal={t("editTile")}
        setIsShown={setIsEditDialogOpened}
        isShown={isEditDialogOpened}
        negativeAction={() => {
          setIsEditDialogOpened(false);
          setTileValueInChanging(
            card.TILE_VALUE === " "
              ? [{ LINK_NAME: "", LINK_URL: "" }]
              : [
                  {
                    LINK_NAME: card.TILE_VALUE.split(";")[0],
                    LINK_URL: card.TILE_VALUE.split(";")[1],
                  },
                ]
          );
        }}
        content={
          <>
            <div className="tile-information">
              <span className="tile-name fs-28">{card.TILE_NAME}</span>
              <span className="tile-audience-type fs-16">
                {card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE
                  ? t("privateTile") + " | " + card.TILE_TYPE
                  : t("publicTile") + " | " + card.TILE_TYPE}
              </span>
            </div>
            <FieldsInForm
              fields={argsForEditTextTileDialog.fieldsForEditLinksTile}
              onSubmit={argsForEditTextTileDialog.onSubmit}
              findFormErrors={argsForEditTextTileDialog.findFormErrors}
              submitOccurred={submitOccurred}
              setSubmitOccurred={setSubmitOccurred}
            />
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("saveEdits")}
        positiveAction={() => setSubmitOccurred(true)}
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal edit-tile-modal full-view-tile-modal"
        titleOfModal={
          <div className="tile-information">
            <span className="tile-name fs-28">{card.TILE_NAME}</span>
            <span className="tile-audience-type fs-16">
              {card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE
                ? t("privateTile") + " | " + card.TILE_TYPE
                : t("publicTile") + " | " + card.TILE_TYPE}
            </span>
          </div>
        }
        setIsShown={setTextIsClicked}
        isShown={textIsClicked}
        negativeAction={() => setTextIsClicked(false)}
        content={
          <>
            <div className="tile-full-view-content">
              {tile_value_is_changing.map((link, index) => {
                return (
                  <div
                    key={link.LINK_NAME + index}
                    className="source-full-view"
                  >
                    <span className="source-link-name">{link.LINK_NAME}</span>
                    <span
                      className="link"
                      onClick={() => {
                        let finalLink =
                          link.LINK_URL.includes("https://") ||
                          link.LINK_URL.includes("http://")
                            ? link.LINK_URL
                            : "https://" + link.LINK_URL;
                        window.open(
                          finalLink,
                          link.LINK_URL.includes("app.reghub.io")
                            ? "_self"
                            : "_blank"
                        );
                      }}
                    >
                      <img
                        width={24}
                        height={24}
                        src={
                          link.LINK_URL.includes("app.reghub.io")
                            ? iconsCrossLink
                            : iconsExternalLink
                        }
                        className="link-icon-source-icon"
                      />
                      <span className="link-name-source">
                        {" "}
                        {link.LINK_URL}{" "}
                      </span>
                    </span>
                  </div>
                );
              })}
            </div>
          </>
        }
        isBackdrop="static"
        isCentered={true}
      />
      {successMessage ? (
        <AlertMessage
          variant="success"
          onClose={() => {
            filterSuccessMessageRaised(successMessage);
            setSuccessMessage("");
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      ) : (
        <div className="display-none" />
      )}
      {failureMessage ? (
        <AlertMessage
          variant="danger"
          onClose={() => {
            filterFailureMessageRaised(failureMessage);
            setFailureMessage("");
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      ) : (
        <div className="display-none" />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    singleTile: state.tileReducer.singleTile,
    singleTopic: state.topicReducer.singleTopic,
    tileTypes: state.tileReducer.tileTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteTile: bindActionCreators(deleteTile, dispatch),
    updateTile: bindActionCreators(updateTile, dispatch),
    addNewsItem: bindActionCreators(addNewsItem, dispatch),
    getFilterTypes: bindActionCreators(getFilterTypes, dispatch),
  };
};

CardSourceCustom.propTypes = {
  card: PropTypes.shape({
    CREATED_BY: PropTypes.string,
    TILE_AUDIENCE: PropTypes.string,
    TILE_ICON_PATH: PropTypes.string,
    TILE_ID: PropTypes.number,
    TILE_LAST_UPDATE: PropTypes.string,
    TILE_NAME: PropTypes.string,
    TILE_STATUS: PropTypes.string,
    TILE_TYPE: PropTypes.string,
    TILE_VALUE: PropTypes.string,
    CREATOR_LOGO: PropTypes.string,
    PARTNER: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }).isRequired,
  userEmail: PropTypes.string.isRequired,
  singleTopic: PropTypes.shape({
    TOPIC_ID: PropTypes.number,
    TOPIC_NAME: PropTypes.string,
  }),
  userToken: PropTypes.string.isRequired,
  deleteTile: PropTypes.func.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }).isRequired,
  updateTile: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fromDocumentContainer: PropTypes.bool,
  fromCardAssessmentContainer: PropTypes.bool,
  singleTile: PropTypes.shape({
    TILE_ID: PropTypes.number,
  }).isRequired,
  // addNewsItem: PropTypes.func.isRequired,
  getFilterTypes: PropTypes.func.isRequired,
  tileTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

CardSourceCustom.defaultProps = {
  card: {
    CREATED_BY: "",
    TILE_AUDIENCE: "",
    TILE_ICON_PATH: "",
    TILE_ID: 0,
    TILE_LAST_UPDATE: "",
    TILE_NAME: "",
    TILE_STATUS: "",
    TILE_TYPE: "",
    TILE_VALUE: "",
    CREATOR_LOGO: "",
    PARTNER: "",
  },
  userEmail: "",
  singleTopic: {},
  userToken: "",
  deleteTile: () => {},
  currentWorkspace: {},
  updateTile: () => {},
  id: "",
  fromDocumentContainer: false,
  fromCardAssessmentContainer: false,
  singleTile: {},
  pushTile: () => {},
  addNewsItem: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(CardSourceCustom);
